import React from 'react';
import styled from 'styled-components';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { black, lightGray, lightGrayThird } from '../assets/ui/colors';

const CardItem = styled.div`
    border: 1px solid ${lightGray};
    border-radius: 4px;
    margin: 8px;
    padding: 17px 22px 17px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: 0.3s;
    background: ${lightGray};
    color: ${black};
    font-size: 16px;
    line-height: 22px;
    :hover {
        background: ${lightGrayThird};
    }
`;

export const Price = styled.div`
    margin-left: auto;
    color: ${black};
    margin-right: 24px;
    @media (max-width: 600px) {
        margin-right: 12px;
    }
`;

const SimpleCard = ({
    label,
    price,
}) => {

    return (
        <CardItem>
            {label}
            {price && <Price>{price / 100} &#8381;</Price>}
            <ArrowRightIcon />
        </CardItem>
    )
}

export default SimpleCard;
